<template>
  <div>
  <v-container fluid id="admin-panel-dashboard">
    <v-row>
      <v-col v-if="!this.isTablet" class="charts" :cols="6">
        <v-toolbar class="chart-toolbar" height="35px;">
          <v-toolbar-title class="welcome-user-practice">Overview</v-toolbar-title>
          <select-with-button
            :value="currentTimespan"
            :items="timespanOptions"
            @input="setTimespan"
            label="Select Time Span"
            class="toolbar-select" 
            id="select-time-span-dropdown"/>
          <v-spacer/>
          <v-btn text 
          class="reports"
          @click="$emit('clickedGoToReports')">
            <v-avatar size="24" class="mr-2">
              <img :src="require('../../assets/' + coloredAssetUrls.reports)" />
            </v-avatar>Go To Reports
          </v-btn>
        </v-toolbar>

        <v-layout row>
          <v-flex d-inline md4>
            <div class="patients-avatar">
              <img class="patients-logo" src="../../assets/Patients-background.svg" />
              <div class="patient-graph-text">
                <span class="patients-count">{{patientNum}}</span>
                <span class="patients-title">{{patientNum == 1 ? "visit": "visits"}}</span>
              </div>
            </div>
          </v-flex>
          <v-flex v-if="!isToday" d-inline md8>
            <line-chart
              :chart-data="patientsDatacollection"
              :options="options"
              class="patient-chart secondary"
              :styles="myStyles"></line-chart>
          </v-flex>
        </v-layout>

        <v-layout row>
          <v-flex d-inline md4>
            <div class="patients-avatar">
              <img class="patients-logo" src="../../assets/Exams-background.svg" />
              <div class="patient-graph-text">
                <span class="patients-count">{{examNum}}</span>
                <span class="patients-title">Exams</span>
              </div>
            </div>
          </v-flex>
          <v-flex v-if="!isToday" d-inline md8>
            <line-chart
              :chart-data="examsDatacollection"
              :options="options"
              class="patient-chart secondary"
              :styles="myStyles"></line-chart>
          </v-flex>
        </v-layout>

        <v-layout row>
          <v-flex d-inline md4>
            <div class="patients-avatar">
              <img class="patients-logo" src="../../assets/Images-background.svg" />
              <div class="patient-graph-text">
                <span class="patients-count">{{imageNum}}</span>
                <span class="patients-title">Images</span>
              </div>
            </div>
          </v-flex>
          <v-flex v-if="!isToday" d-inline md8>
            <line-chart
              :chart-data="imagesDatacollection"
              :options="options"
              class="patient-chart secondary"
              :styles="myStyles"></line-chart>
          </v-flex>
        </v-layout>
      </v-col>

      <v-col v-else class="charts" :cols="12">
        <v-toolbar class="chart-toolbar" height="35px;">
          <v-toolbar-title class="welcome-user-practice">Overview</v-toolbar-title>
          <select-with-button
            :value="currentTimespan"
            :items="timespanOptions"
            @input="setTimespan"
            label="Select Time Span"
            class="toolbar-select" 
            id="select-time-span-dropdown"/>
          <v-spacer/>
           <v-btn text 
          class="reports"
          @click="$emit('clickedGoToReports')">
            <v-avatar size="24" class="mr-2">
              <img :src="require('../../assets/' + coloredAssetUrls.reports)" />
            </v-avatar>Go To Reports
          </v-btn>
        </v-toolbar>

        <v-layout>
          <v-flex d-inline md4>
            <div class="patients-avatar">
              <img class="patients-logo" src="../../assets/Patients-background.svg" />
              <div class="patient-graph-text">
                <span class="patients-count">{{patientNum}}</span>
                <span class="patients-title">{{patientNum == 1 ? "visit": "visits"}}</span>
              </div>
            </div>
          </v-flex>

          <v-flex d-inline md4>
            <div class="patients-avatar">
              <img class="patients-logo" src="../../assets/Exams-background.svg" />
              <div class="patient-graph-text">
                <span class="patients-count">{{examNum}}</span>
                <span class="patients-title">Exams</span>
              </div>
            </div>
          </v-flex>

          <v-flex d-inline md4>
            <div class="patients-avatar">
              <img class="patients-logo" src="../../assets/Images-background.svg" />
              <div class="patient-graph-text">
                <span class="patients-count">{{imageNum}}</span>
                <span class="patients-title">Images</span>
              </div>
            </div>
          </v-flex>
        </v-layout>
      </v-col>
            
      <v-col class="tables" :cols="this.isTablet ? '12' : '6'">
        <v-toolbar class="chart-toolbar" height="35px;">
          <v-toolbar-title class="welcome-user-practice">System Status</v-toolbar-title>
          <select-with-button
            v-if="activeTab == 'users'"
            :value="currentPatientFilter"
            :items="patientOptions"
            @change="patientFilter"
            label="Patient Filter"
            class="toolbar-select"/>
          <select-with-button
            v-else-if="activeTab == 'physicians'"
            :value="currentPhysicianFilter.value"
            :text="currentPhysicianFilter.text"
            :items="physicianOptions"
            @change="physicianFilter"
            label="Physician Filter"
            class="toolbar-select"/>
          <select-with-button
            v-else-if="activeTab == 'devices'"
            :value="currentDeviceFilter"
            :items="deviceOptions"
            @change="deviceFilter"
            label="Device Filter"
            class="toolbar-select"/>
          <v-spacer/>
        </v-toolbar>
        <v-tabs v-model="activeTab"
          height="100"
          color="transparent"
          grow>
          <v-tab
            href="#users"
            key="users"
            class="tab"
            :class="[(activeTab === 'users') ? 'activeTab' : '']"
            :style="borderStyle"
            @change="setDefaultUserFilter">
            <img class="tab-logo" :src="require('../../assets/' + coloredAssetUrls.usersBackground)" />
            <v-toolbar-title class="tab-text" :class="tabClass">
              <span>{{userNo}}</span>
              <br />
              <span style="tab-text">Active</span>
              <br />
              <span>Users</span>
            </v-toolbar-title>
          </v-tab>

          <v-tab
            href="#physicians"
            key="physicians"
            class="tab"
            :class="[(activeTab === 'physicians') ? 'activeTab' : '', 
              (activeTab === 'users') ? 'activeNextTab' : '']"
            :style="borderStyle"
            @change="setDefaultPhysicianFilter">
            <img class="tab-logo" :src="require('../../assets/' + coloredAssetUrls.physicianBackground)" />
            <v-toolbar-title class="tab-text" :class="tabClass">
              <span>{{phyNo}}</span>
              <br />
              <span>Active</span>
              <br />
              <span>physicians</span>
            </v-toolbar-title>
          </v-tab>      
          <v-tab
            href="#devices"
            key="devices"
            class="tab"
            :style="borderStyle"
            @change="setDefaultDeviceFilter"
            :class="[(activeTab === 'devices') ? 'activeTab' : '', 
              (activeTab === 'physicians') ? 'activeNextTab' : '']">
            <img class="tab-logo" :src="require('../../assets/' + coloredAssetUrls.devicesBackground)" />
            <v-toolbar-title class="tab-text" :class="tabClass">
              <span>{{deviceNo}}</span>
              <br />
              <span style="tab-text">Active</span>
              <br />
              <span>Devices</span>
            </v-toolbar-title>
          </v-tab>       
          <v-tab
            href="#configure"
            key="configure"
            class="tab"
            :style="borderStyle"
            :class="[(activeTab === 'configure') ? 'activeTab' : '', 
              (activeTab === 'devices') ? 'activeNextTab' : '']">
            <img class="tab-logo" :src="require('../../assets/' + coloredAssetUrls.configure)" />
            <v-toolbar-title class="tab-text" :class="tabClass">
              <span>Configure</span>
            </v-toolbar-title>
          </v-tab>     
        </v-tabs>

        <v-tabs-items v-model="activeTab" id="admin-panel-data-table">
          <v-tab-item value="users">
            <v-btn text @click="handleAddUser">
              <v-avatar size="20" class="mr-1">
                <img :src="require('../../assets/' + coloredAssetUrls.addPatient)" />
              </v-avatar>Add User
            </v-btn>
            <v-data-table :headers="userheaders"
              :items="filteredUsers"
              sort-by="lName">
              <template slot="item" slot-scope="props" style="overflow: scroll;">
                <tr :class="getUserRowStyle(props.item.dept)" @click ="handleUpdateUser(props.item)">
                  <td>{{ props.item.status}}</td>
                  <td>{{ props.item.lName }}</td>
                  <td>{{ props.item.fName }}</td>
                  <td>{{ props.item.id }}</td>
                  <td>{{ props.item.desig }}</td>
                  <td>{{ props.item.practiceGroups }}</td>
                </tr>
              </template>
            </v-data-table>
          </v-tab-item>

          <v-tab-item value="physicians">
            <v-btn text @click="handleAddPhysician">
              <v-avatar size="20" class="mr-1">
                <img :src="require('../../assets/' + coloredAssetUrls.addPatient)" />
              </v-avatar>Add Physician
            </v-btn>
            <v-data-table :headers="phyheaders"
              :items="filteredPhysicians"
              sort-by="lastName"
              @click:row="handleUpdatePhysician">
              <template slot="items" slot-scope="props" style="overflow: scroll;">
                <tr>
                  <td>{{ props.item.status }}</td>
                  <td>{{ props.item.phyLName }}</td>
                  <td>{{ props.item.phyFName }}</td>
                  <td>{{ props.item.phySrNo }}</td>
                  <td>{{ props.item.phyLevel }}</td>
                  <td>{{ props.item.associatedUserName }}</td>
                </tr>
              </template>
            </v-data-table>
          </v-tab-item>

          <v-tab-item value="devices">
            <v-btn v-if="this.addEditDeviceUI" text @click="handleAddDevice">
              <v-avatar size="20" class="mr-1">
                <img :src="require('../../assets/' + coloredAssetUrls.addPatient)" />
              </v-avatar>Add Device
            </v-btn>
            <v-data-table :headers="devheaders"
              :items="filteredDevices"
              sort-by="activeDate">
              <template slot="item" slot-scope="props" style="overflow: scroll;">
                <tr @click ="handleUpdateDevice(props.item)">
                  <td>{{ transformBooltoText(props.item.isActive) }}</td>
                  <td>{{ props.item.srNo }}</td>
                  <td>{{ props.item.devLicense }}</td>
                  <td>{{ props.item.procedure }}</td>
                  <td>{{ props.item.description }}</td>
                  <td>{{ props.item.location }}</td>
                  <td>{{ props.item.physicalSerialNum }}</td>
                  <td>{{ transformDate(props.item.activeDate)}}</td>
                </tr>
              </template>
            </v-data-table>
          </v-tab-item>

          <v-tab-item value="configure">
            <div id="configurationTab">
              <div class= "configurationSection">
                <div class="tabHeader">
                  <div class="tabHeaderText text-uppercase">Viewing Defaults</div>
                </div>
                <div class="tabBody">
                  <v-row>
                    <v-col cols="7">
                      <div class="text-uppercase" :class="colorClass">patient listing on login</div>
                      <div :class="colorClass">(sets which subgroup of patients are displayed when users first login)</div>
                    </v-col>
                    <v-col cols="5">
                      <select-with-button
                          class="select-btn"
                          v-model="configureSetting.patientDefaultListing"
                          :items="defaultPatientListingOption"
                          name="configureSetting.patientDefaultListing"
                          data-vv-as="configureSetting.patientDefaultListing"
                          solo/>
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col cols="7">
                      <div class="text-uppercase" :class="colorClass">visual fields eye order</div>
                      <div :class="colorClass">(sets which eye is displayed on left and right sides of screen for HVF single view)</div>
                    </v-col>
                    <v-col cols="5">
                      <select-with-button
                          class="select-btn"
                          v-model="configureSetting.useDefaultHVF"
                          :items="defaultHVFOption"
                          name="configureSetting.useDefaultHVF"
                          data-vv-as="configureSetting.useDefaultHVF"
                          solo/>
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col cols="7">
                      <div class="text-uppercase" :class="colorClass">override multiview hvf check</div>
                      <div :class="colorClass">(if set to True, will not check for single fields in Multiview)</div>
                    </v-col>
                    <v-col cols="5">
                      <select-with-button
                          class="select-btn"
                          v-model="configureSetting.overrideMultiviewHVFCheck"
                          :items="trueOrFalseOption"
                          name="configureSetting.overrideMultiviewHVFCheck"
                          data-vv-as="configureSetting.overrideMultiviewHVFCheck"
                          solo/>
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col cols="7">
                      <div class="text-uppercase" :class="colorClass">default HVF view</div>
                      <div :class="colorClass">(set default viewer (single or multiview) for HVF image)</div>
                    </v-col>
                    <v-col cols="5">
                      <select-with-button
                          class="select-btn"
                          v-model="configureSetting.siteDefaultHVFview"
                          :items="defaultHVFViewerOption"
                          name="configureSetting.siteDefaultHVFview"
                          data-vv-as="configureSetting.siteDefaultHVFview"
                          solo/>
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col cols="7">
                      <div class="text-uppercase" :class="colorClass">default Macular Cube scan display ratio</div>
                      <div :class="colorClass">(set default display ratio (original or stretch) for Cirrus Macular Cube scan)</div>
                    </v-col>
                    <v-col cols="5">
                      <select-with-button
                          class="select-btn"
                          v-model="configureSetting.cirrusScanDisplayRatio"
                          :items="defaultCirrusScanRatioOption"
                          name="configureSetting.cirrusScanDisplayRatio"
                          data-vv-as="configureSetting.cirrusScanDisplayRatio"
                          solo/>
                    </v-col>
                  </v-row>
                </div>
              </div>
              <div class= "configurationSection">
                <div class="tabHeader">
                  <div class="tabHeaderText text-uppercase">Security</div>
                </div>
                <div class="tabBody">
                  <v-row>
                    <v-col cols="7">
                      <div class="text-uppercase" :class="colorClass">user inactivity time limit</div>
                      <div :class="colorClass">(denotes time after which an inactive user will be automatically logged out)</div>
                    </v-col>
                    <v-col cols="4">
                       <v-text-field
                        :class="colorClass"
                        type="number"
                        v-model="configureSetting.userInactivityTimeLimit"
                        name="configureSetting.userInactivityTimeLimit"
                        data-vv-as="configureSetting.userInactivityTimeLimit"
                        solo/>
                    </v-col>
                    <v-col cols="1">
                      <label :class="colorClass">minutes</label>
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col cols="7">
                      <div class="text-uppercase" :class="colorClass">lockout enabled</div>
                      <div :class="colorClass">(whether user will be locked out after failed )</div>
                    </v-col>
                    <v-col cols="5">
                      <select-with-button
                          class="select-btn"
                          v-model="configureSetting.userLockoutEnabled"
                          :items="trueOrFalseOption"
                          name="configureSetting.userLockoutEnabled"
                          data-vv-as="configureSetting.userLockoutEnabled"
                          solo/>
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col cols="7">
                      <div class="text-uppercase" :class="lockoutSettingsTextColor">max failed login attempts</div>
                      <div :class="lockoutSettingsTextColor">(number of failed attempts before user is locked out)</div>
                    </v-col>
                    <v-col cols="4">
                       <v-text-field
                        :class="colorClass"
                        type="number"
                        v-model="configureSetting.userFailedLoginAttempts"
                        name="configureSetting.userFailedLoginAttempts"
                        data-vv-as="configureSetting.userFailedLoginAttempts"
                        :disabled=!configureSetting.userLockoutEnabled
                        :background-color="lockoutSettingsBackgroundColor"
                        :min="1"
                        solo/>
                    </v-col>
                    <v-col cols="1">
                      <label :class="lockoutSettingsTextColor">attempts</label>
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col cols="7">
                      <div class="text-uppercase" :class="lockoutSettingsTextColor">lockout duration</div>
                      <div :class="lockoutSettingsTextColor">(how long the user is locked out for)</div>
                    </v-col>
                    <v-col cols="4">
                       <v-text-field
                        :class="colorClass"
                        type="number"
                        v-model="configureSetting.userLockoutDuration"
                        name="configureSetting.userLockoutDuration"
                        data-vv-as="configureSetting.userLockoutDuration"
                        :disabled=!configureSetting.userLockoutEnabled
                        :background-color="lockoutSettingsBackgroundColor"
                        :min="1"
                        solo/>
                    </v-col>
                    <v-col cols="1">
                      <label :class="lockoutSettingsTextColor">minutes</label>
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col cols="7">
                      <div class="text-uppercase" :class="lockoutSettingsTextColor">reset failed login attempts</div>
                      <div :class="lockoutSettingsTextColor">(how long until the number of failed login attempts is reset)</div>
                    </v-col>
                    <v-col cols="4">
                       <v-text-field
                        :class="colorClass"
                        type="number"
                        v-model="configureSetting.userFailedLoginAttemptsReset"
                        name="configureSetting.userFailedLoginAttemptsReset"
                        data-vv-as="configureSetting.userFailedLoginAttemptsReset"
                        :disabled=!configureSetting.userLockoutEnabled
                        :background-color="lockoutSettingsBackgroundColor"
                        :min="1"
                        solo/>
                    </v-col>
                    <v-col cols="1">
                      <label :class="lockoutSettingsTextColor">minutes</label>
                    </v-col>
                  </v-row>
                </div>
              </div>
              <div class= "configurationSection">
                <div class="tabHeader">
                  <div class="tabHeaderText text-uppercase">active directory</div>
                </div>
                <div class="tabBody">
                  <v-row>
                    <v-col cols="7">
                      <div class="text-uppercase" :class="colorClass">enable active directory authentication using ldap</div>
                      <div :class="colorClass">(users managed through active directory separate from AXIS administrator center)</div>
                    </v-col>
                    <v-col cols="5">
                       <select-with-button
                          class="select-btn"
                          v-model="configureSetting.actDirEnabled"
                          :items="enableOrDisableOption"
                          name="configureSetting.actDirEnabled"
                          data-vv-as="configureSetting.actDirEnabled"
                          solo/>
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col cols="7">
                      <div class="text-uppercase" :class="actDirTextColor">active directory path</div>
                    </v-col>
                    <v-col cols="5">
                       <v-text-field
                        :class="colorClass"
                        type="text"
                        v-model="configureSetting.actDirPath"
                        name="configureSetting.actDirPath"
                        data-vv-as="configureSetting.actDirPath"
                        :disabled="isActDirEnabled == false"
                        :background-color="actDirBackgroundColor"
                        solo/>
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col cols="7">
                      <div class="text-uppercase" :class="actDirTextColor">active directory admin users</div>
                      <div :class="actDirTextColor">(active directory group defining AXIS Admin users)</div>
                    </v-col>
                    <v-col cols="5">
                       <v-text-field
                        :class="colorClass"
                        type="text"
                        v-model="configureSetting.actDirGroupAxisAdmin"
                        name="configureSetting.actDirGroupAxisAdmin"
                        data-vv-as="configureSetting.actDirGroupAxisAdmin"
                        :disabled="isActDirEnabled == false"
                        :background-color="actDirBackgroundColor"
                        class="greyBackground"
                        solo/>
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col cols="7">
                      <div class="text-uppercase" :class="actDirTextColor">active directory attending physician</div>
                      <div :class="actDirTextColor">(active directory group defining AXIS Attending Physicians)</div>
                    </v-col>
                    <v-col cols="5">
                       <v-text-field
                        :class="colorClass"
                        type="text"
                        v-model="configureSetting.actDirGroupAxisAttndMD"
                        name="configureSetting.actDirGroupAxisAttndMD"
                        data-vv-as="configureSetting.actDirGroupAxisAttndMD"
                        :disabled="isActDirEnabled == false"
                        :background-color="actDirBackgroundColor"
                        solo/>
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col cols="7">
                      <div class="text-uppercase" :class="actDirTextColor">active directory referring physician</div>
                      <div :class="actDirTextColor">(active directory group defining AXIS Referring Physicians)</div>
                    </v-col>
                    <v-col cols="5">
                       <v-text-field
                        :class="colorClass"
                        type="text"
                        v-model="configureSetting.actDirGroupAxisRefMD"
                        name="configureSetting.actDirGroupAxisRefMD"
                        data-vv-as="configureSetting.actDirGroupAxisRefMD"
                        :disabled="isActDirEnabled == false"
                        :background-color="actDirBackgroundColor"
                        solo/>
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col cols="7">
                      <div class="text-uppercase" :class="actDirTextColor">active directory user</div>
                      <div :class="actDirTextColor">(active directory group defining AXIS General User)</div>
                    </v-col>
                    <v-col cols="5">
                       <v-text-field
                        :class="colorClass"
                        type="text"
                        v-model="configureSetting.actDirGroupAxisUser"
                        name="configureSetting.actDirGroupAxisUser"
                        data-vv-as="configureSetting.actDirGroupAxisUser"
                        :disabled="isActDirEnabled == false"
                        :background-color="actDirBackgroundColor"
                        solo/>
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col cols="7">
                      <div class="text-uppercase" :class="actDirTextColor">active directory read only</div>
                      <div :class="actDirTextColor">(active directory group defining AXIS Read Only User)</div>
                    </v-col>
                    <v-col cols="5">
                       <v-text-field
                        :class="colorClass"
                        type="text"
                        v-model="configureSetting.actDirGroupAxisReadOnly"
                        name="configureSetting.actDirGroupAxisReadOnly"
                        data-vv-as="configureSetting.actDirGroupAxisReadOnly"
                        :disabled="isActDirEnabled == false"
                        :background-color="actDirBackgroundColor"
                        solo/>
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col cols="7">
                      <div class="text-uppercase" :class="actDirTextColor">active directory view only</div>
                      <div :class="actDirTextColor">(active directory group defining AXIS View Only User)</div>
                    </v-col>
                    <v-col cols="5">
                       <v-text-field
                        :class="colorClass"
                        type="text"
                        v-model="configureSetting.actDirGroupAxisViewOnly"
                        name="configureSetting.actDirGroupAxisViewOnly"
                        data-vv-as="configureSetting.actDirGroupAxisViewOnly"
                        :disabled="isActDirEnabled == false"
                        :background-color="actDirBackgroundColor"
                        solo/>
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col cols="7">
                      <div class="text-uppercase" :class="actDirTextColor">active directory photographer</div>
                      <div :class="actDirTextColor">(active directory group defining AXIS Photographer User)</div>
                    </v-col>
                    <v-col cols="5">
                       <v-text-field
                        :class="colorClass"
                        type="text"
                        v-model="configureSetting.actDirGroupAxisPhotographer"
                        name="configureSetting.actDirGroupAxisPhotographer"
                        data-vv-as="configureSetting.actDirGroupAxisPhotographer"
                        :disabled="isActDirEnabled == false"
                        :background-color="actDirBackgroundColor"
                        solo/>
                    </v-col>
                  </v-row>
                </div>
              </div>
              <div class= "configurationSection pb-5">
                <div class="tabHeader"></div>
                <div class="tabBody pt-3">
                  <v-row>
                    <v-col cols="12">
                      <v-btn class="modal-cta" @click.stop.prevent="updateConfiguration">Submit</v-btn>
                    </v-col>
                  </v-row>
                </div>
              </div>
            </div>
          </v-tab-item>
        </v-tabs-items>
      </v-col>
    </v-row>
  </v-container>
  <add-user
    :isOpen="userModal"
    :isUpdate="update"
    :user="userObj"
    :isEDSADUser="isEDSADUser"
    @close="handleCloseUser"
    @submit="handleSubmitUser"/>
  <add-physician
    :isOpen="physicianModal"
    :isUpdate="update"
    :users="associatedUsers"
    :physician="physicianObj"
    @close="handleClosePhysician"
    @submit="handleSubmitPhysician"/>
  <add-device
    :isOpen="deviceModal"
    :isUpdate="update"
    :device="deviceObj"
    :deviceHistory="deviceHistory"
    :pagination="deviceHistoryPagination"
    @close="handleCloseDevice"
    @submit="handleSubmitDevice"
    @getDeviceHistory="handleGetDeviceHistory"
    @updateDeviceHistorySort="updateDeviceHistorySort"
    @handleDeviceHistoryPagination="handleDeviceHistoryPagination"/>
  </div>
</template>
<script>
import { mapGetters, mapActions } from "vuex";
import { isoDateTimeFormat, isoDateFormat } from "../../helpers/dateUtils";
import moment from "moment";
import LineChart from "../charts/LineChart.js";
import addUser from "./AddUser";
import addPhysician from "./AddPhysician";
import addDevice from "./AddDevice";
import selectWithButton from "../controls/SelectWithButton";
import { PATIENT_TIMESPANS, PATIENT_TIMESPAN, DEFAULT_PATIENT_LISTING, DEFAULT_HVF, TRUE_OR_FALSE, ENABLE_OR_DISABLE, SINGLE_OR_MULTI, DEFAULT_MACULAR_CUBE_SCAN_RATIO, DEV_CONFIG_XML_VALUES, DEVICE_HISTORY_SORTBY, DEVICE_HISTORY_EDITABLE_FIELDS
 } from "../../config/config";

export default {
  name: "AdminPanelDashboard",
  components: {
    LineChart,
    addUser,
    addPhysician,
    addDevice,
    selectWithButton
  },
  data() {
    return {
      timespanOptions: PATIENT_TIMESPANS,
      timespans: PATIENT_TIMESPAN,
      defaultPatientListingOption: DEFAULT_PATIENT_LISTING,
      defaultHVFOption: DEFAULT_HVF,
      defaultHVFViewerOption: SINGLE_OR_MULTI,
      defaultCirrusScanRatioOption: DEFAULT_MACULAR_CUBE_SCAN_RATIO,
      trueOrFalseOption: TRUE_OR_FALSE,
      enableOrDisableOption: ENABLE_OR_DISABLE,
      DEV_CONFIG_XML_VALUES: DEV_CONFIG_XML_VALUES,
      DEVICE_HISTORY_SORTBY: DEVICE_HISTORY_SORTBY,
      DEVICE_HISTORY_EDITABLE_FIELDS: DEVICE_HISTORY_EDITABLE_FIELDS,
      currentTimespan: "",
      patientNum: 0,
      examNum: 0,
      imageNum: 0,
      currentPatientFilter: "Active",
      patientOptions: [
        {
          text: "View Active",
          value: "Active",
        },
        {
          text: "View Inactive",
          value: "Inactive",
        },
        {
          text: "View Active and Inactive",
          value: "Both",
        }
      ],
      currentPhysicianFilter: {
        text: "View Active",
        value: 1,
      },
      physicianOptions: [
        {
          text: "View Active",
          value: 1,
        },
        {
          text: "View Inactive",
          value: 0,
        },
        {
          text: "View Active and Inactive",
          value: "Both",
        }
      ],
      currentDeviceFilter: {
        text: "View Active Devices",
        value: "Active",
      },
      deviceOptions: [
        {
          text: "View Active Devices",
          value: "Active",
        },
        {
          text: "View Inactive Devices",
          value: "Inactive",
        },
        {
          text: "View Active and Inactive Devices",
          value: "Both",
        }
      ],
      userModal: false,
      physicianModal: false,
      deviceModal: false,
      activeTab: "users",
      patientsDatacollection: {},
      examsDatacollection: {},
      imagesDatacollection: {},
      height: 160,
      width: 100,
      userNo: 0,
      phyNo: 0,
      deviceNo: 0,
      options: {
        maintainAspectRatio: false,
        legend: {
          display: false
        },
        scales: {
          yAxes: [
            {
              ticks: {
                fontColor: "white"
              }
            }
          ],
          xAxes: [
            {
              ticks: {
                fontColor: "white"
              }
            }
          ]
        },
        
      },
      userheaders: [
        {
          text: "Status",
          value: "status"
        },
        {
          text: "Last Name",
          value: "lName"
        },
        {
          text: "First Name",
          value: "fName"
        },
        {
          text: "User ID",
          value: "id"
        },
        {
          text: "Role",
          value: "desig"
        },
        {
          text: "Group(s)",
          value: "practiceGroups"
        }
      ],
      phyheaders: [
        {
          text: "Status",
          value: "status"
        },
        {
          text: "Last Name",
          value: "lastName"
        },
        {
          text: "First Name",
          value: "firstName"
        },
        {
          text: "User ID",
          value: "userId"
        },
        {
          text: "Designation",
          value: "phyLevel"
        },
        {
          text: "Associated User",
          value: "associatedUserName"
        }
      ],
      devheaders: [
        {
          text: "Status",
          value: "isActive"
        },
        {
          text: "ID No.",
          value: "srNo"
        },
        {
          text: "License",
          value: "devLicense"
        },
        {
          text: "Exam Type (Dev Proc)",
          value: "devProc"
        },
        {
          text: "Device Description",
          value: "description"
        },
        {
          text: "Physical Location",
          value: "location"
        },
        {
          text: "Serial Number",
          value: "physicalSerialNum"
        },
        {
          text: "Date Activated",
          value: "activeDate"
        }
      ],
      users: [],
      filteredUsers: [],
      associatedUsers: [],
      deviceList: [],
      filteredDevices: [],
      deviceHistory: [],
      deviceHistoryPages: 1,
      deviceHistoryPagination: {
        sortDesc: true,
        sortBy: DEVICE_HISTORY_SORTBY.TmStamp,
        devSrNo: 0
      },
      physicianList: [],
      filteredPhysicians: [],
      patientsData: [],
      patientsDate: [],
      examDate:[],
      examData: [],
      imageData: [],
      imageDate: [],
      month: "",
      update: false,
      userObj: 
      {
        id: null,
        password: null,
        fName: null,
        lName: null,
        isActive: null,
        desig: null,
        contactNumber: null,
        email: null,
        changePWD: false,
        changePWDMust: false,
        userPrefMenu: false,
        srNo: -1,
        act: "Save"
      },
      isEDSADUser: false,
      physicianObj: 
      {
        srNo: 0,
        usrSrNo: null,
        fName: null,
        lName: null,
        name: null,
        phyLevel: null,
        modalityList: [],
        isSelected: false,
        associatedUser: null,
        act: "Save"
      },
      deviceObj: {
        devSrNo: 0,
        devType: null,
        devName: null,
        devProc: null,
        devDescrition: null,
        isActive: false,
        ignoreRotation: false,
        orderByLaterality: false,
        defaultZoomFactor: null,
        devConfigInput: [
          {
            id: 1,
            type: null,
            value: null,
            description: null,
          }
        ],
        devConfig: null
      },
      configureSetting:{
        patientDefaultListing: 1,
        useDefaultHVF: true,
        overrideMultiviewHVFCheck: true,
        userInactivityTimeLimit: 0,
        cirrusScanDisplayRatio: "original",
        actDirEnabled: false,
        actDirPath: "",
        actDirGroupAxisAdmin: "",
        actDirGroupAxisAttndMD: "",
        actDirGroupAxisRefMD: "",
        actDirGroupAxisUser: "",
        actDirGroupAxisReadOnly: "",
        actDirGroupAxisViewOnly: "",
        actDirGroupAxisPhotographer: "",
        siteDefaultHVFview: "",
        userLockoutEnabled: false,
        userFailedLoginAttempts: 0,
        userLockoutDuration: 0,
        userFailedLoginAttemptsReset: 0
      },
      chartTypes:{
        Patients: 0,
        Exams: 1,
        Files: 2
      },
      dateRangeTypes:{
        Today: 0,
        ThisWeek: 1,
        ThisMonth: 2,
        ThisYear: 3,
        All: 4
      }
    };
  },
  beforeMount() {
    this.$store.dispatch("getUserList")
      .then(response => {
        this.users = response.data.data;
        this.users.forEach(e => {
          e.name = e.fName + " " + e.lName;
          e.isActive = e.status == "Active" ? true : false;
          e.practiceGroups = this.getPracticeGroupsString(e.practiceGroupId);
        });
        this.associatedUsers = [{name: " ", srNo: 0}].concat(this.users);
        this.userNo = this.users.filter(e => {
          return e.status == "Active";
        }).length;
        this.filteredUsers = this.users.filter(e => {
          return e.status == this.currentPatientFilter;
        });
        this.physicianList = this.physicians;
        this.updatePhysicianData();
    });

    this.getCharts(moment().startOf("year").format(isoDateTimeFormat), this.dateRangeTypes.ThisYear)
    this.deviceList = this.devices;
    this.deviceNo = this.devices.filter(e => {
          return e.isActive == true;
        }).length;
    this.deviceFilter(this.currentDeviceFilter.value);

    this.currentTimespan = this.timespanOptions[3];
    this.getConfigureSiteSetting();
    this.getConfigureActDirSetting();
  },
  mounted() {
    this.activeTab = "users";
  },
  updated() {},
  computed: {
    ...mapGetters(["userFullName", "userIsAdmin", "widthTablet", "physicians", "devices", "isActDirEnabled", "siteInfo", "practiceGroupsList", "deviceLogs"]),
    myStyles() {
      return {
        height: `${this.height}px`,
        width: "90%",
        marginLeft: "30px"
      };
    },
    isToday() {
      return this.currentTimespan == "Today's Patients";
    },
    isTablet() {
      return this.widthTablet;
    },
    isActDirEnabled(){
      return this.configureSetting.actDirEnabled;
    },
    actDirTextColor() {
      return this.isActDirEnabled ? this.colorClass : "greyText";
    },
    actDirBackgroundColor() {
      return this.isActDirEnabled ? "" : "grey darken-2";
    },
    isUserLockoutEnabled(){
      return this.configureSetting.userLockoutEnabled;
    },
    lockoutSettingsTextColor() {
      return this.isUserLockoutEnabled ? this.colorClass : "greyText";
    },
    lockoutSettingsBackgroundColor(){
      return this.isUserLockoutEnabled ? "" : "grey darken-2";
    },
    addEditDeviceUI() {
      return this.siteInfo.addEditDeviceUI;
    }
  },
  methods: {
    ...mapActions(["processUser", "getUserList", "processPhysician", "getPhysicians", "processDevice", "getDevices", "getDeviceLogs"]),
    updatePhysicianData(){
      this.physicianList = this.physicians;
      this.physicianList.forEach(e => {
          if (e.phyStatus == 1)
            e.status = "Active";
          else
            e.status = "Inactive";
          let user = this.users.filter(f => {
            return f.srNo == e.phyUsrSrNo;
          })[0];
          if (user) {
            e.associatedUser = user;
            e.email = user.email;
            e.phoneNumber = user.contactNumber;
            e.userId = e.phyUsrSrNo;
            e.associatedUserName = user.name;
          }else{
            e.associatedUser = this.associatedUsers[0];
          }
      });
      this.phyNo = this.physicianList.filter(e => {
          return e.phyStatus == 1;
        }).length;
        this.filteredPhysicians = this.physicianList.filter(e => {
          return e.phyStatus == 1;
        });
    },
    getPracticeGroupsString(practiceGroupsIds){
      let practiceGroupsString = [];
      practiceGroupsIds.forEach(e => {
        let group = this.practiceGroupsList.filter(obj => { return obj.practiceGroupId == e})
        practiceGroupsString.push(group[0].name);
      });
      return practiceGroupsString.join(", ");
    },
    updateConfiguration(){
      let n = (this.configureSetting.userInactivityTimeLimit - Math.floor(this.configureSetting.userInactivityTimeLimit));  
      if(n !== 0 || this.configureSetting.userInactivityTimeLimit <= 1 ){
        this.$store.commit("displayStatus", { message: "User Inactivity time limit must be a whole number and greater than 1.", level: "error" });
        return;
      }

      if(this.configureSetting.userLockoutEnabled){
        let attempt = (this.configureSetting.userFailedLoginAttempts - Math.floor(this.configureSetting.userFailedLoginAttempts));   
        let duration = (this.configureSetting.userLockoutDuration - Math.floor(this.configureSetting.userLockoutDuration)); 
        let reset = (this.configureSetting.userFailedLoginAttemptsReset - Math.floor(this.configureSetting.userFailedLoginAttemptsReset)); 

        if(attempt !== 0 || this.configureSetting.userFailedLoginAttempts <= 0 || duration !== 0 || this.configureSetting.userLockoutDuration <= 0 || reset !== 0 || this.configureSetting.userFailedLoginAttemptsReset <= 0){
          this.$store.commit("displayStatus", { message: "All lockout settings must be a whole number and greater than 1.", level: "error" });
          return;
        }
      }

      this.$store.dispatch("setAxisSettings", this.configureSetting);
    },
    getConfigureSiteSetting(){
      this.configureSetting.patientDefaultListing = this.patientDefaultListingValue(this.siteInfo.defaultPatientListing);
      this.configureSetting.useDefaultHVF = this.siteInfo.useDefaultHvf;
      this.configureSetting.overrideMultiviewHVFCheck = this.siteInfo.overrideMultiviewHVFCheck;
      this.configureSetting.userInactivityTimeLimit = this.siteInfo.userInactivityTimeLimit;
      this.configureSetting.siteDefaultHVFview = this.siteInfo.siteDefaultHVFview;
      this.configureSetting.cirrusScanDisplayRatio = this.siteInfo.cirrusScanDisplayRatio;
      this.configureSetting.userLockoutEnabled= this.siteInfo.userLockoutEnabled;
      this.configureSetting.userFailedLoginAttempts= this.siteInfo.userFailedLoginAttempts;
      this.configureSetting.userLockoutDuration= this.siteInfo.userLockoutDuration;
      this.configureSetting.userFailedLoginAttemptsReset= this.siteInfo.userFailedLoginAttemptsReset;
    },
    getConfigureActDirSetting(){
      this.$store.dispatch("getActDir").then(response => {
        this.configureSetting.actDirEnabled = response.data.isEnabled;
        this.configureSetting.actDirPath = response.data.ldapPathList;
        this.configureSetting.actDirGroupAxisAdmin = response.data.groupAdmin;
        this.configureSetting.actDirGroupAxisAttndMD = response.data.groupAttdMD;
        this.configureSetting.actDirGroupAxisRefMD = response.data.groupRefMD;
        this.configureSetting.actDirGroupAxisUser = response.data.groupUser;
        this.configureSetting.actDirGroupAxisReadOnly = response.data.groupReadOnly;
        this.configureSetting.actDirGroupAxisViewOnly = response.data.groupViewOnly;
        this.configureSetting.actDirGroupAxisPhotographer = response.data.groupPhotographer ;
      });
    },
    patientDefaultListingValue(stringValue){
      stringValue = stringValue.toUpperCase();
      let value = 0;
      switch(stringValue){
        case "DAY":
          value = 1;
          break;
        case "WEEK":
          value = 2;
          break;
        case "MONTH":
          value = 3;
          break;
        case "YEAR":
          value = 4;
          break;
        case "ALL":
          value = 5;
          break;
      }

      return value;
    },
    getUserRowStyle(dept){
      if(dept === "EDSADUSER")
        return "grey-out-user-row";
      else return "";
    },
    fillPatientsData() {
      this.patientsDatacollection = {
        labels: this.patientsDate,
        datasets: [
          {
            borderColor: this.colorHex,
            data: this.patientsData
          }
        ]
      };
    },
    fillExamsData() {
      this.examsDatacollection = {
        labels: this.examDate,
        datasets: [
          {
            borderColor: this.colorHex,
            data: this.examData
          }
        ]
      };
    },
    fillImagesData() {
      this.imagesDatacollection = {
        labels: this.imageDate,
        datasets: [
          {
            borderColor: this.colorHex,
            data: this.imageData
          }
        ]
      };
    },
    handleAddUser() {
      this.userModal = true;
      this.update = false;
      this.userObj = {
        id: null,
        password: "",
        fName: null,
        lName: null,
        isActive: null,
        desig: null,
        contactNumber: null,
        email: null,
        changePWD: false,
        changePWDMust: false,
        userPrefMenu: false,
        srNo: -1,
        act: "Save"
      }
    },
    handleUpdateUser(user) {
      this.userModal = true;      
      this.userObj = user;
      this.userObj.isActive = user.status == "Active" ? true : false;
      this.userObj.password = "";
      this.userObj.confirmPass = "";
      this.userObj.act = "Update";
      this.userObj.userPrefMenu = user.userPrefMenu;
      this.update = true;
      if (user.dept != "EDSADUSER")
        this.isEDSADUser = false;
      else
        this.isEDSADUser = true;
    },
    handleCloseUser() {
      this.userModal = false; 
      this.update = false;
      this.userObj = {
        id: null,
        password: "",
        fName: null,
        lName: null,
        isActive: null,
        desig: null,
        contactNumber: null,
        email: null,
        changePWD: false,
        changePWDMust: false,
        userPrefMenu: false,
        srNo: -1
      }
    },
    handleSubmitUser(user) {
      this.processUser(user)
        .then(() => 
          this.handleCloseUser()
        )
        .catch(error => Promise.reject(error.response))
        .finally(() => {
          this.getUserList()
            .then(response => {
              this.users = response.data.data;
              this.users.forEach(e => {
                e.name = e.fName + " " + e.lName;
                e.isActive = e.status == "Active" ? true : false;
                e.practiceGroups = this.getPracticeGroupsString(e.practiceGroupId);
              });
              this.userNo = this.users.filter(e => {
                return e.status == "Active";
              }).length;
              this.patientFilter(this.currentPatientFilter);
            })
        });
    },
    handleAddPhysician() {
      this.physicianModal = true;
      this.update = false;
      this.physicianObj = {
        srNo: 0,
        usrSrNo: null,
        fName: null,
        lName: null,
        name: null,
        phyLevel: null,
        phyStatus: null,
        modalityList: [],
        isSelected: false,
        associatedUser: null,
        act: "Save"
      };
    },
    handleUpdatePhysician(physician) {
      this.physicianModal = true;     
      this.physicianObj = {
        srNo: physician.phySrNo,
        usrSrNo: physician.phyUsrSrNo,
        fName: physician.firstName,
        lName: physician.lastName,
        name: physician.firstName + " " + physician.lastName,
        phyLevel: physician.phyLevel.toUpperCase(),
        phyStatus: physician.phyStatus,
        modalityList: physician.modalityList || [],
        isSelected: physician.isSelected,
        associatedUser: physician.associatedUser,
        act: "Update"
      };
      this.update = true;
    },
    handleClosePhysician() {
      this.physicianModal = false; 
      this.update = false;
      this.physicianObj = {
        srNo: null,
        usrSrNo: null,
        fName: null,
        lName: null,
        name: null,
        phyLevel: null,
        phyStatus: null,
        modalityList: null,
        isSelected: null,
        associatedUser: null
      }
    },
    handleSubmitPhysician(physician) {
      this.processPhysician(physician)
        .then(() => 
          this.handleClosePhysician()
        )
        .catch(error => Promise.reject(error.response))
        .finally(() => {
          this.getPhysicians(true)
            .then(() => {     
              this.physicianList = this.physicians;      
              this.updatePhysicianData();
              this.physicianFilter(this.currentPhysicianFilter.value);
            })
        });
    },
    handleAddDevice() {
      this.deviceModal = true;
      this.deviceObj = {
        devSrNo: 0,
        devType: null,
        devName: null,
        devProc: null,
        devDescrition: null,
        isActive: false,
        ignoreRotation: false,
        orderByLaterality: false,
        defaultZoomFactor: null,
        devConfigInput: [
          {
            id: 1,
            type: null,
            value: null,
            description: null,
          }
        ],
        devConfig: null
      };
      this.deviceHistory = [];
      this.deviceHistoryPages = 1;
      this.deviceHistoryPagination = {
        sortDesc: true,
        sortBy: DEVICE_HISTORY_SORTBY.TmStamp,
      }
    },
    handleUpdateDevice(device) {
      this.deviceModal = true;
      this.deviceObj = {
        devSrNo: device.srNo,
        devType: device.type,
        devName: device.name,
        devProc: device.procedure,
        devDescrition: device.description,
        isActive: device.isActive,
        ignoreRotation: device.ignoreRotation,
        orderByLaterality: device.orderByLaterality,
        defaultZoomFactor: device.defaultZoomFactor,
        devConfigInput: [],
        devConfig: null
      };
      if (device.configs) 
      {
        for (var i = 0; i < device.configs.length; i++)
          this.deviceObj.devConfigInput.push(
          {
            id: i + 1,
            type: DEV_CONFIG_XML_VALUES.find(e => e.text == device.configs[i].type).value,
            value: device.configs[i].value,
            description: device.configs[i].desc
          });
      }
      else
        this.deviceObj.devConfigInput = 
        [
          {
            id: 1,
            type: null,
            value: null,
            description: null,
          }
        ];
      this.update = true;
      this.deviceHistoryPagination = {
        sortDesc: true,
        sortBy: DEVICE_HISTORY_SORTBY.TmStamp,
      }
      this.deviceHistoryPages = 1;
      this.handleGetDeviceHistory();
    },
    handleCloseDevice() {
      this.deviceModal = false; 
      this.deviceObj = {
        devSrNo: 0,
        devType: null,
        devName: null,
        devProc: null,
        devDescrition: null,
        isActive: false,
        ignoreRotation: false,
        orderByLaterality: false,
        defaultZoomFactor: null,
        devConfigInput: [
          {
            id: 1,
            type: null,
            value: null,
            description: null,
          }
        ],
        devConfig: null
      };
      this.deviceHistory = [];
      this.deviceHistoryPages = 1;
      this.deviceHistoryPagination = {
        sortDesc: true,
        sortBy: DEVICE_HISTORY_SORTBY.TmStamp,
      }
    },
    handleSubmitDevice(device) {
      this.processDevice(device)
        .then(() => 
          this.handleCloseDevice()
        )
        .catch(error => Promise.reject(error.response))
        .finally(() => {
          this.getDevices(true)
            .then(() => {     
              this.deviceList = this.devices;      
              this.deviceFilter(this.currentDeviceFilter.value);
              this.deviceNo = this.devices.filter(e => {
                return e.isActive == true;
              }).length;
            })
        });
    },
    handleGetDeviceHistory() {
      this.deviceHistoryPagination.devSrNo = this.deviceObj.devSrNo;
      this.getDeviceLogs(this.deviceHistoryPagination)
        .then((response) =>  
        {
          this.deviceHistory = this.calculateDeviceHistoryDifferences(response.data.data.items);
          this.deviceHistoryPages = Math.ceil(response.data.data.total / this.deviceHistoryPagination.itemsPerPage);
        });
    },
    updateDeviceHistorySort(data) {
        if (data.key.length > 0) 
        {
            this.deviceHistoryPagination.sortDesc = data.order && data.order.length > 0 ? true : false;
            switch (data.key[0]) 
            {
                case "username":            
                    this.deviceHistoryPagination.sortBy = DEVICE_HISTORY_SORTBY.Username
                    break;
                case "tmStamp":            
                    this.deviceHistoryPagination.sortBy = DEVICE_HISTORY_SORTBY.TmStamp
                    break;
                case "oldValues":            
                    this.deviceHistoryPagination.sortBy = DEVICE_HISTORY_SORTBY.OldValues
                    break;
                case "newValues":            
                    this.deviceHistoryPagination.sortBy = DEVICE_HISTORY_SORTBY.NewValues
                    break;
            }
        }
        else 
        {
            this.deviceHistoryPagination.sortDesc = true;
            this.deviceHistoryPagination.sortBy = DEVICE_HISTORY_SORTBY.TmStamp;
        }
        this.deviceHistoryPagination.page = data.page;
        this.handleGetDeviceHistory();
    },
    handleDeviceHistoryPagination(data) {
        this.deviceHistoryPagination.page = data.page;
        this.handleGetDeviceHistory();
    },
    calculateDeviceHistoryDifferences(deviceLogs) 
    {
      let calculatedLogs = [];
      for (let i = 0; i < deviceLogs.length; i++) {
        if (deviceLogs[i].oldValues == "") 
        {
          let firstObject = {
            tmStamp: deviceLogs[i].tmStamp, 
            username: deviceLogs[i].username,
            field: "All",
            oldValues: "-",
            newValues: deviceLogs[i].newValues,
          };
          calculatedLogs.push(firstObject);
        }
        else 
        {
          let oldJson = JSON.parse(deviceLogs[i].oldValues);
          let newJson = JSON.parse(deviceLogs[i].newValues);
          for (let key in oldJson) {
            if (DEVICE_HISTORY_EDITABLE_FIELDS.includes(key.toLowerCase()))  
            {
              if (oldJson[key] != newJson[key]) 
              {
                let diffObject = {
                  tmStamp: deviceLogs[i].tmStamp, 
                  username: deviceLogs[i].username,
                  field: key,
                  oldValues: oldJson[key],
                  newValues: newJson[key],
                };
                calculatedLogs.push(diffObject);
              }
            }
          }  
        }
      }
      return calculatedLogs;
    },
    setDefaultUserFilter() {
      this.patientFilter("Active");
    },
    patientFilter(filter) {
      this.currentPatientFilter = filter;
      if (filter == "Both") 
        this.filteredUsers = this.users;
      else 
        this.filteredUsers = this.users.filter(e => {
          return e.status == filter;
        });
    },
    setDefaultPhysicianFilter() {
      this.currentPhysicianFilter = {
        text: "View Active",
        value: 1,
      };
      this.physicianFilter(this.currentPhysicianFilter.value);
    },
    physicianFilter(filter) {
      if (filter == "Both") 
        this.filteredPhysicians = this.physicianList;
      else 
        this.filteredPhysicians = this.physicianList.filter(e => {
          return e.phyStatus == filter;
        });
      this.currentPhysicianFilter = this.physicianOptions.filter(e => {
        return e.value == filter;
      })[0];
    },
    setDefaultDeviceFilter() {
      this.currentDeviceFilter = {
        text: "View Active Devices",
        value: "Active",
      };
      this.deviceFilter(this.currentDeviceFilter.value);
    },
    transformBooltoText(value){
      if(value){
        return "Active";
      }
      else{
        return "Inactive";
      }
    },
    transformIntToText(value){
      if(value == 1){
        return "Active";
      }
      else{
        return "Inactive";
      }
    },
    transformDate(value){
      return moment(value).format(isoDateFormat);
    },
    deviceFilter(filter) {
      if (filter == "Both"){
        this.filteredDevices = this.deviceList;
      }  
      else if(filter == "Active"){
        this.filteredDevices = this.deviceList.filter(e => {
          return e.isActive == true;
        });
      }       
      else if(filter == "Inactive"){
        this.filteredDevices = this.deviceList.filter(e => {
          return e.isActive == false;
        });
      }       
    },
    setTimespan(value) {
      // Reset all data for the charts
      this.patientsData = [];
      this.patientsDate = [];
      this.examData = [];
      this.examDate = [];
      this.imageData = [];
      this.imageDate = [];
      this.patientNum = 0;
      this.examNum = 0;
      this.imageNum = 0;
      this.fillPatientsData();
      this.fillExamsData();
      this.fillImagesData();

      // Logic for setting the timespan for the api call
      this.currentTimespan = value;
      let timespan = null;
      let dateRangeType = null;

      switch (value) {
        case this.timespanOptions[0]:
          timespan = moment()
          .startOf("day")
          .format(isoDateTimeFormat);
          dateRangeType = this.dateRangeTypes.Today;
          break;
        case this.timespanOptions[1]:
          timespan = moment()
          .startOf("week")
          .format(isoDateTimeFormat);
          dateRangeType = this.dateRangeTypes.ThisWeek;
          break;
        case this.timespanOptions[2]:
          timespan = moment()
          .startOf("month")
          .format(isoDateTimeFormat);
          dateRangeType = this.dateRangeTypes.ThisMonth;
          break;
        case this.timespanOptions[3]:
          timespan = moment()
          .startOf("year")
          .format(isoDateTimeFormat);
          dateRangeType = this.dateRangeTypes.ThisYear;
          break;
        case this.timespanOptions[4]:
          dateRangeType = this.dateRangeTypes.All;
          break;
      }
      this.getCharts(timespan, dateRangeType);
    },
    getCharts(dateStart, dateRangeType){
      Object.values(this.chartTypes).forEach(val =>{
        let request = {
          ChartType: val,
          DateRangeType: dateRangeType,
          DateStart: dateStart,
          DateEnd: moment().endOf("day").format(isoDateTimeFormat),
        };

        this.getChartResult(request);
      });
    },
    getChartResult(request){
      this.$store.dispatch("getChartResult", request)
      .then(response => {
        if(response.data.data.length > 0){
          this.processCharts(response.data.data, request.ChartType, request.DateRangeType);
        }      
      });
    },
    processCharts(data, chartTypes, dateRange){
      if(dateRange == this.dateRangeTypes.ThisWeek){
        data = this.sortDataForWeek(data);
      }
      let {labels, chartData} = this.formatDataset(data, dateRange);
      let {labelKey, dataKey, countKey} = this.getDataKeys(chartTypes);
      this[labelKey] = labels;
      this[dataKey] = chartData;
      this[countKey] = this[dataKey].reduce(function(a, b){
        return a + b;
      }, 0);
      switch(chartTypes){
        case this.chartTypes.Patients:
          this.fillPatientsData();
          break;
        case this.chartTypes.Exams:
          this.fillExamsData();
          break;
        case this.chartTypes.Files:
          this.fillImagesData();
          break;
      }
    },
    populateLabel(data, dateRange){
      // populate label
      var thisMonth = moment().format("MMMM");
      var thisYear = moment().format("YYYY");
      let labelSet = [];
      let label = "";
      data.forEach(e=> {
        if(dateRange == this.dateRangeTypes.Today)
        {
          label = thisMonth + " " + e.label;
        }
        else if(dateRange == this.dateRangeTypes.ThisYear){
          label = moment(e.label, "M").format("MMMM") + " " + thisYear;
        }
        else{// all - group by year
          label = e.label;
        }

        if (!labelSet.includes(label))
          labelSet.push(label);
      });

      return labelSet;
    },
    populateChartData(data){
      let dataSet = [];
      data.forEach(function(item, index) { 
        if (index > 0) {
          if (item.label == data[index - 1].label)
            dataSet[dataSet.length - 1] += item.count;
          else
            dataSet.push(item.count);
        } 
        else
          dataSet.push(item.count);
      });
      return dataSet;
    },
    sortDataForWeek(data){
      var lastDayofPreviousMonth = moment().subtract(1,"months").endOf("month").format("D");
      var today = moment().format("D");
      var lastMonthRecord = [];
      var currentMonthRecord = [];

      for(var i = 0; i < data.length; i++){
        if(data[i].label > today && data[i].label <= lastDayofPreviousMonth)
        {
          lastMonthRecord.push(data[i]);
        }
        else{
          currentMonthRecord.push(data[i]);
        }
      }

      return lastMonthRecord.concat(currentMonthRecord);
    },
    formatDataset(data, dateRange) {
      let returnObj = {};
      if (dateRange == this.dateRangeTypes.ThisWeek)
        returnObj = this.formatDatasetsForWeek(data);
      else if (dateRange == this.dateRangeTypes.ThisMonth)
        returnObj = this.formatDatasetsForMonth(data);
      else {
        returnObj.chartData = this.populateChartData(data);
        returnObj.labels = this.populateLabel(data, dateRange);
      }
      return returnObj;
    },
    formatDatasetsForMonth(data) {
      var thisMonth = moment().format("MMMM");
      let returnObj = {chartData: [0, 0, 0, 0, 0], labels: ["", "", "", "", ""], values: ["a1-7", "b8-14", "c15-21", "d22-28", "29+"]};
      for (let i = 0; i < 28; i += 7) {
        returnObj.labels[i / 7] = thisMonth + " " + (i + 1) + " - " + (i + 7);
      }
      returnObj.labels[4] = thisMonth + " 29+";
      data.forEach(e => {
        let index = returnObj.values.indexOf(e.label);
        returnObj.chartData[index] += e.count;
      })
      return returnObj;
    },
    formatDatasetsForWeek(data) {
      var weekStart = parseInt(moment().startOf("week").format("D"));
      var lastDayofPreviousMonth = parseInt(moment().subtract(1,"months").endOf("month").format("D"));
      var thisMonth = moment().format("MMMM");
      var lastMonth = moment().subtract(1,"months").format("MMMM");
      let returnObj = {chartData: [0, 0, 0, 0, 0, 0, 0], labels: ["", "", "", "", "", "", ""], value: ["", "", "", "", "", "", ""]};
      if (weekStart + 6 > lastDayofPreviousMonth) {
        for (let i = weekStart; i <= lastDayofPreviousMonth; i++) {
          returnObj.labels[i - weekStart] = lastMonth + " " + i;
          returnObj.value[i - weekStart] =  i;
        }
        for (let i = 1; i <= 6 - (lastDayofPreviousMonth - weekStart); i++) {
          returnObj.labels[i + lastDayofPreviousMonth - weekStart] = thisMonth + " " + i;
          returnObj.value[i + lastDayofPreviousMonth - weekStart] =  i;
        }
      }
      else {
        for (let i = weekStart; i < weekStart + 7; i++) {
          returnObj.labels[i - weekStart] = thisMonth + " " + i;
          returnObj.value[i - weekStart] =  i;
        }
      }
      data.forEach(e => {
        let index = returnObj.value.findIndex(x => x == e.label);
        returnObj.chartData[index] += e.count;
      })
      return returnObj;
    },
    getDataKeys(type) {
      let returnObj = {labelKey: "", dataKey: "", countKey: ""}
      switch(type){
        case this.chartTypes.Patients:
          returnObj.labelKey = "patientsDate";
          returnObj.dataKey = "patientsData";
          returnObj.countKey = "patientNum";
          break;
        case this.chartTypes.Exams:
          returnObj.labelKey = "examDate";
          returnObj.dataKey = "examData";
          returnObj.countKey = "examNum";
          break;
        case this.chartTypes.Files:
          returnObj.labelKey = "imageDate";
          returnObj.dataKey = "imageData";
          returnObj.countKey = "imageNum";
          break;
      }
      return returnObj;
    }
  }
};
</script>
<style lang="scss">
  #admin-panel-dashboard {
    overflow-y: auto;
    height: calc( 100vh - 55px);

    .blueTheme.v-text-field input{
      color: $color-blue !important;
    }
    .greenTheme.v-text-field input{
      color: $color-light-green !important;
    }
    .grayTheme.v-text-field input{
      color: $color-light-gray !important;
    }
  }
  #select-time-span-dropdown{
    label{
      color: #00b0f0;
      height: 30px;
    }
  }
  #admin-panel-data-table{
    border-left: 1px solid #FFFFFF;
    .v-select__selection--comma{
      color: #000000;
      padding-left: 7px;
    }
    .v-select__slot{
      width: 80px;
    }
  }
  #configurationTab{
    padding-top: 25px;
    .tabHeader{
      border-bottom: #7f7f7f 1px solid;
      .tabHeaderText{
        padding-left: 25px;
      }
    }
    .tabBody{
      padding-left: 25px;
      padding-right: 15px;
    }
    .greyText{
      color: #7f7f7f
    }
    .v-select__slot{
      width: 100%;
    }
  }
</style>
<style lang="scss" scoped>

.sub-toolbar {
  background-color: black !important;
  text-align: center;
  overflow: hidden;
  display: flex;
  justify-content: center;

  .welcome-user-practice {
    font-size: 30px !important;
  }
}

.tables {
  padding: 0px 0px 0px 0px;
}

.charts {
  margin: 0;
  padding: 0px 0px 0px 0px;

  .patients-avatar {
    text-align: center;
    display: inline;
    .patients-logo {
      height: 160px;
      margin-top: 10px;
      margin-left: 20px;
      margin-bottom: 10px;
    }

    .patient-graph-text {
      margin-top: -110px;
      margin-left: -60px;
      font-size: 40px;
      text-align: right;
      text-transform: uppercase;
      
      .patients-count {
        display: block;
        line-height: 1;
      }

      .patients-title {
        color: $color-grey;
      }
    }
  }
}

.chart-toolbar {
  padding: 0;
  margin: 0;
  text-transform: uppercase;
}

.tab {
  border-left: 1px;
  border-right: 1px;
  border-bottom: 1px solid white !important;
  border-style: solid;
}

.activeTab {
  border-left: 1px;
  border-right: 1px;
  border-bottom: 1px solid transparent !important;
  border-style: solid;

  .tab-text {
    font-weight: 700;
  }

  .lightTab {
    color: black;
  }

  .darkTab {
    color: white;
  }
}

.activeNextTab {
  border-left: 1px solid transparent !important;
}

.tab-logo {
  height: 70px;
}

.tab-text {
  display: block;
}

.activeDirectory {
  color: $color-blue !important;
  margin-left: 10px;
}
.grey-out-user-row{
  color: $color-grey;
}

@media screen and (max-width: 1024px){
  .charts {
    .patients-avatar {
      .patient-graph-text {
        margin-right: 20px;
        margin-left: 0px;
      }
   }
  }
}
</style>